import React, { useState } from "react";
import CustomTooltip from "../../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faDownload } from "@fortawesome/free-solid-svg-icons";
import { toast } from "../../../../components/ui/use-toast";
import { ResponsiveDrawerForm } from "../../../../components/ResponsiveDrawerForm";
import moment from "moment";
import PolicyApproveModal from "./PolicyApproveModal";

const PolicyActionButton = ({
  id,
  approved,
  approvalPremission,
  fetchPolicies,
  item,
}) => {
  const [showApprove, setShowApprove] = useState(false);
  const [nextModal, setNextModal] = useState(false);
  const [reviewDate, setReviewDate] = useState(moment().add(1, "year"));
  const [complianceManagerId, setComplianceManagerId] = useState();

  const toggleApproveModal = () => {
    setShowApprove(!showApprove);
  };

  const handleDownload = async (export_report_path) => {
    try {
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute("download", file[file.length - 1] || "file.pdf");
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    } catch (e) {
      const errors = e.response?.data?.errors;
      toast({
        variant: "destructive",
        description: errors,
        duration: 3000,
      });
    }
  };

  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"Download"}>
          <span>
            <FontAwesomeIcon
              onClick={() => handleDownload(item?.file)}
              icon={faDownload}
              size="1x"
              data-toggle="modal"
              data-target="#clientDetail"
            />
          </span>
        </CustomTooltip>
        {!approved ? (
          <>
            {approvalPremission ? (
              <>
                <span>/</span>
                <CustomTooltip message={"Approve"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      size="1x"
                      onClick={() => {
                        toggleApproveModal();
                      }}
                    />
                  </span>
                </CustomTooltip>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </span>
      {showApprove && (
        <ResponsiveDrawerForm
          description={""}
          title={"Approve Policy"}
          handleOpen={() => {}}
          handleClose={() => {
            setNextModal(false);
            setReviewDate(moment().add(1, "year"));
            setComplianceManagerId();
          }}
          className="sm:max-w-1/2"
          open={showApprove}
          buttonClassName={""}
          setOpen={setShowApprove}
          mobileCancelHidden={true}
          confirmBox={true}
          write={true}
        >
          <PolicyApproveModal
            id={id}
            fetchPolicies={fetchPolicies}
            nextModal={nextModal}
            setNextModal={setNextModal}
            toggleApproveModal={toggleApproveModal}
            setReviewDate={setReviewDate}
            setComplianceManagerId={setComplianceManagerId}
            reviewDate={reviewDate}
            complianceManagerId={complianceManagerId}
          />
        </ResponsiveDrawerForm>
      )}
    </>
  );
};

export default PolicyActionButton;
